import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black py-10 md:py-14 border-t border-[#333]">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 items-start">
          <div className="text-center md:text-left">
            <img
              src="https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/5b0e55db21655eca8e03e44a17fcce4c.png"
              alt="EasyMarketPro - AI Customer Support Agents"
              className="h-8 w-auto mb-3 mx-auto md:mx-0"
            />
            <p className="text-[13px] text-[#888] leading-[1.6]">
              <strong>AI customer support agents</strong> that reduce ticket volume.
            </p>
            <a
              href="mailto:info@easymarketpro.tech"
              className="text-[#B8985F] text-[13px] hover:text-[#D4B06A] transition-colors cursor-pointer mt-2 inline-block"
            >
              info@easymarketpro.tech
            </a>
            <div className="flex items-center gap-3 mt-4 justify-center md:justify-start">
              <a
                href="https://www.linkedin.com/company/easymarketpro/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#222] hover:bg-[#B8985F] text-[#999] hover:text-white transition-all cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-[15px]"></i>
              </a>
              <a
                href="https://www.instagram.com/easymarketpro.io/?next=%2F&hl=en"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#222] hover:bg-[#B8985F] text-[#999] hover:text-white transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-[15px]"></i>
              </a>
              <a
                href="https://web.facebook.com/profile.php?id=61554422263442"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#222] hover:bg-[#B8985F] text-[#999] hover:text-white transition-all cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-[15px]"></i>
              </a>
              <a
                href="https://x.com/EasymarketproHQ"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#222] hover:bg-[#B8985F] text-[#999] hover:text-white transition-all cursor-pointer"
                aria-label="Twitter/X"
              >
                <i className="ri-twitter-x-fill text-[15px]"></i>
              </a>
            </div>
          </div>

          <nav className="space-y-3 text-center md:text-left">
            <h4 className="text-[13px] font-semibold text-white mb-4">
              <a href="/" className="hover:text-[#B8985F] transition-colors">Navigation</a>
            </h4>
            <a
              href="/#how-it-works"
              className="block text-[#888] text-[13px] hover:text-[#B8985F] transition-colors cursor-pointer"
            >
              How It Works
            </a>
            <a
              href="/#use-cases"
              className="block text-[#888] text-[13px] hover:text-[#B8985F] transition-colors cursor-pointer"
            >
              Use Cases
            </a>
            <Link
              to="/about"
              className="block text-[#888] text-[13px] hover:text-[#B8985F] transition-colors cursor-pointer"
            >
              About
            </Link>
            <Link
              to="/book-a-call"
              className="block text-[#888] text-[13px] hover:text-[#B8985F] transition-colors cursor-pointer"
            >
              Book a Call
            </Link>
          </nav>

          <div className="text-center md:text-right">
            <p className="text-[#888] text-[13px]">&copy; 2025 EasyMarketPro. All rights reserved.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-[#666] text-[12px] hover:text-[#B8985F] transition-colors mt-2 inline-block cursor-pointer"
            >
              Web Design
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
